import React, { useState, useRef, useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import {
  Select,
  MenuItem,
  Button,
  TextField,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Card,
  CardContent,
  Paper,
  IconButton,
  FormHelperText,
  Typography,
  Avatar,
  CardMedia,
} from '@mui/material'
import { useForm } from 'react-hook-form'
import Tabs, { tabsClasses } from '@mui/material/Tabs'
import './AddMediaCoverage.css'
import UploadIcon from '@mui/icons-material/Upload'
import { useDispatch, useSelector } from 'react-redux'
import { getMediaCoverageTypesList } from 'store/action/mediaCoverageList'
import { postCreateOpeds } from 'store/action/createNewOpeds'
import { useLoading } from 'utils/LoadingContext'
import { useNotificationContext } from 'utils/NotificationContext'
import {
  getMediaCoverageList,
  getMediaCoverageListByMpID,
  getOpedsAndBooksList,
  getOpedsAndBooksListByMpID,
  getOnlyMediaCoverageList,
  getOnlyMediaCoverageListByMpID,
} from '../../../store/action/mediaCoverageList'
import closeIconp from '../../../asserts/images/close.png'
import Constant, { allowedImageFormat, acceptedImageFormat, defaultErrorMessage } from '../../../utils/constant'
import { getIds } from '../../ReusableComponents.js/getIds'
import DeleteMediaCoverageDialog from './DeleteMediaCoverageDialog'
import {
  validateNotEmpty,
  iconComponent,
  iconComponentDown,
  handleFileName,
  onPdfFileUpload,
  getVideoFileDuration,
} from '../../ReusableComponents.js/reuseMethods'
import CrossIcon from '../../../asserts/images/Close.svg'
import NoImageFound from '../../../asserts/images/noImageFound.jpg'
import { uploadMedia, uploadFile } from '../../../utils/mediaUpload'
import { makeLogRequest } from '../../../utils/AuditLogs'
import { pushTag } from '../../../utils/gtmservice'
import AddPdfComponent from '../../ReusableComponents.js/AddPdfComponent'
import PdfCard from '../../ReusableComponents.js/PdfCard'
import VideoTrimDialog from '../../ReusableComponents.js/VideoTrimDialog/VideoTrimDialog'
import { getFramesFromVideo, getTrimmedVideo } from 'utils/VideoTrimService'

const AddMediaCoverage = ({
  handleCloseMediaCoverage,
  openMediaCoverage,
  onViewClickTitle,
  onViewClickTitleValue,
  isMediaCoverageEdit,
  details,
  handleCloseInitiativeDetails,
  mpId,
  opedsByMpId,
  setCheckIsUpdate,
  limit = 10,
  tenure,
}) => {
  const [images, setImages] = useState([])
  // const [value, setValue] = useState(0);
  const [files, setFiles] = useState([])
  const dispatch = useDispatch()
  const { setLoading } = useLoading()
  const { showNotification } = useNotificationContext()
  const [selectArrow, setSelectArrow] = useState(true)
  const [checkUpdateChanges, setCheckUpdateChanges] = useState(true)
  const mediaCoverageTypesListData = useSelector((state) => state?.mediaCoverageTypesList?.data)
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    reset,
    setValue,
    setError,
    clearErrors,
  } = useForm()
  const hiddenFileInput = useRef(null)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [deleteClick, setDeleteClick] = useState(false)
  const [checkImages, setCheckImages] = useState(false)
  const mpProfileData = useSelector((state) => state?.mpProfileData?.data[0])
  const [checkDescError, setCheckDescError] = useState(false)
  const [checkDescValue, setCheckDescValue] = useState(false)
  const [url, setUrl] = useState('')
  const [checkDescChanges, setCheckDescChanges] = useState(false)
  const [videoData, setVideoData] = useState(null)
  const [openVideoTrimDialog, setOpenVideoTrimDialog] = useState(false)

  const loggedInId = getIds() // const handleChange = (event, newValue) => {
  //     setValue(newValue);
  // };
  const fileFormats = ['image/png', 'image/jpg']
  const mediaCoverageTypesList =
    onViewClickTitleValue === 5
      ? mediaCoverageTypesListData.filter((val) => val.type !== 'Media Coverage')
      : mediaCoverageTypesListData.filter((val) => val.type == 'Media Coverage')
  const [type, setType] = React.useState(mediaCoverageTypesList && mediaCoverageTypesList[0]?.type)

  const postAuditLogs = async (sqId, id) => {
    await makeLogRequest('my_books_and_media_coverage_edit_popup', sqId, {
      useridtype: getIds(),
      bm_id: id && id,
    })
  }
  const PdfEventFileInput = useRef(null)

  const [detailPdf, setDetailPdf] = useState(
    (typeof details?.detailsPdf == 'string' && details?.detailsPdf !== '[]') ||
      (typeof details?.detailsPdf == 'object' && details?.detailsPdf?.[0])
      ? { name: handleFileName(details?.detailsPdf) }
      : null
  )

  const handlePdfClick = (event) => {
    PdfEventFileInput.current.value = ''

    PdfEventFileInput.current?.click()
    event?.stopPropagation()
    PdfEventFileInput.current.addEventListener('change', () => {
      if (PdfEventFileInput.current.value === '') {
        setCheckUpdateChanges(true)
      } else {
        setCheckUpdateChanges(false)
      }
    })
  }
  useEffect(() => {
    if (!details?.detailsPdf?.[0]) {
      setDetailPdf([])
    }
    if (isMediaCoverageEdit) {
      postAuditLogs('pageload', details?.id)
      sendGALog('edit')
    }
  }, [])

  const handleTypeChange = (event) => {
    setType(event.target.value)
    setError('type', '')
    setCheckUpdateChanges(false)
  }

  const checkTextField = (value, maxLength, minLength, register_name, fieldName) => {
    if (value.length == 0) {
      if (register_name === 'url') {
        clearErrors(`${register_name}`)
        return
      }
      setError(`${register_name}`, {
        type: 'value',
        message: `Please enter ${fieldName}`,
      })
    } else if (value.length > 0 && value.length < minLength) {
      setError(`${register_name}`, {
        type: 'minLength',
        message: `Minimum character length is ${minLength}`,
      })
    } else if (value.length == maxLength) {
      setError(`${register_name}`, {
        type: 'maxLength',
        message: 'Maximum limit reached',
      })
    } else {
      clearErrors(`${register_name}`)
    }
  }

  const setMediaTitle = (e) => {
    let inputValue = e.target.value?.trimStart()
    inputValue = inputValue.replace(/\s{2,}/g, ' ')
    checkTextField(inputValue, 300, 10, 'projectTitle', 'title')
    setValue('projectTitle', inputValue)
    setCheckUpdateChanges(false)
  }

  const handlePaste = async (event) => {
    try {
      const pastedText = await navigator.clipboard.readText()

      // Trim and limit the pasted text to 50 characters
      const trimmedText = pastedText.trim().substring(0, 150)

      // Check if the trimmed text is a valid URL
      if (validateURL(trimmedText)) {
        event.preventDefault()
        setUrl(trimmedText)
        setValue('url', trimmedText)
      }
    } catch (error) {
      console.error('Error reading clipboard data:', error)
    }
  }

  const validateURL = (url) => {
    const trimmedURL = url.trim()
    if (trimmedURL === '') {
      return true
    }
    try {
      // Check if URL starts with 'http://', 'https://', or 'www.'
      if (!trimmedURL.startsWith('http://') && !trimmedURL.startsWith('https://') && !trimmedURL.startsWith('www.')) {
        return 'Not a valid URL'
      }

      const normalizedURL =
        trimmedURL.startsWith('http://') || trimmedURL.startsWith('https://') ? trimmedURL : 'http://' + trimmedURL

      const parsedURL = new URL(normalizedURL)

      const isValidTLD = (tld) => /^[a-z]{1,3}$/.test(tld)

      if (parsedURL.protocol !== 'http:' && parsedURL.protocol !== 'https:') {
        return 'Not a valid URL'
      }

      const domainParts = parsedURL.hostname.split('.')
      const tld = domainParts[domainParts.length - 1].toLowerCase()
      const subdomain = domainParts.length > 2 ? domainParts[0].toLowerCase() : ''

      if (!isValidTLD(tld) || (subdomain.length > 0 && !/^[a-z\d-]{2,3}$/.test(subdomain))) {
        return 'Not a valid URL'
      }

      return true
    } catch (error) {
      return 'Not a valid URL'
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Backspace' && url === '') {
      // Remove the characters one by one when Backspace is pressed and the field is empty
      event.preventDefault()
      const trimmedValue = url.trim()
      const newValue = trimmedValue.slice(0, trimmedValue.length - 1)
      setValue('url', newValue)
      setUrl(newValue)
    } else if (event.key === 'v' && event.ctrlKey && !url) {
      // Allow paste when pressing Ctrl+V and the field is empty
      event.preventDefault()
      handlePaste(event)
    } else if (url !== '' && event.key !== 'Backspace') {
      // Prevent any key press when the field already contains a valid URL
      event.preventDefault()
    }
  }

  const handleInput = (event) => {
    let trimmedInput = event.target.value
    trimmedInput = trimmedInput.trim() // Trim the input value
    checkTextField(trimmedInput, 150, 10, 'url', 'link')
    if (trimmedInput === '') {
      setUrl('')
      setValue('url', '')
    } else {
      if (trimmedInput.startsWith('http://') || trimmedInput.startsWith('https://')) {
        setUrl(trimmedInput)
        setValue('url', trimmedInput)
      }
    }
  }

  const handlePdfChange = (e) => {
    const res = onPdfFileUpload(e, setDetailPdf, showNotification)
    if (res === true) {
      setCheckUpdateChanges(false)
    } else {
      setCheckUpdateChanges(true)
    }
  }
  useEffect(() => {
    if (details) {
      setImages(details?.media && JSON.parse(details?.media))
    }
  }, [details])

  useEffect(() => {
    if (deleteClick) {
      handleCloseMediaCoverage(reset, setImages, setFiles)
    }
  }, [deleteClick])

  const onAddMediaCoverage = async (data) => {
    if (images.length === 0) return
    setLoading(true)
    const tkn = localStorage.getItem('tokenDetails')
    const existingImageUrls = []
    const { imageFiles } = addImagesToFormData(existingImageUrls)
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tkn}`,
      },
    }
    const imagesObj = await uploadMedia(config, { imageFiles: imageFiles }, true)
    let stepUrl = detailPdf ? detailPdf : {}
    if (detailPdf?.size) {
      stepUrl = await uploadMedia(dispatch, { stepPdf: detailPdf })
    } else if (detailPdf) stepUrl.stepPdfUrl = details?.detailsPdf
    else stepUrl.stepPdfUrl = []

    const payloadObj = {
      title: data?.projectTitle,
      url: data?.url,
      type: onViewClickTitleValue === 5 ? data?.type : 'Media Coverage',
      desc: data?.desc,
      detailsPdf: stepUrl?.stepPdfUrl || [],
      mpmodelId: loggedInId,
      media: [...imagesObj?.imageUrls, ...existingImageUrls],
    }
    const id = details?.id ? details?.id : 0
    const parameters = {
      useridtype: getIds(),
      bm_id: id,
    }
    sendCreateMedaiCoverageLogs('submit', parameters)
    sendGALog(isMediaCoverageEdit ? 'edit' : 'proceed')
    try {
      const response = await dispatch(postCreateOpeds(id, payloadObj, config))
      if (response?.status === 200 || response?.status === 201) {
        showNotification('Success', response.data.message, 'success')
        handleCloseMediaCoverage(reset, setImages, setFiles)
        if (details) {
          handleCloseInitiativeDetails({ updated: true })
        }
        const payload = {
          id: 0,
          limit,
          isPrevTenure: tenure === 'Modi 2.0' ? true : false,
        }
        if (onViewClickTitleValue === 5) {
          if (opedsByMpId) {
            payload.id = mpId
            dispatch(getOpedsAndBooksListByMpID(payload))
          } else {
            dispatch(getOpedsAndBooksList(payload))
          }
        } else {
          if (opedsByMpId) {
            payload.id = mpId
            dispatch(getOnlyMediaCoverageListByMpID(payload))
          } else {
            dispatch(getOnlyMediaCoverageList(payload))
          }
        }
        // Object.keys(data).map(val => resetField(val));
        // setImages([]);
        // setFiles([]);
      }
    } catch (error) {
      showNotification('Error', error)
    } finally {
      setLoading(false)
      if (typeof setCheckIsUpdate === 'function') {
        setCheckIsUpdate(true)
      }
    }
  }

  const addImagesToFormData = (existingImageUrls) => {
    const imageFiles = []
    const videoFiles = []
    for (let i = 0; i < images.length; i++) {
      try {
        if (typeof images[i] === 'string' && images[i].toLowerCase().startsWith('https')) {
          existingImageUrls.push({ media: images[i] })
        } else if (images[i].type === 'image') {
          imageFiles.push(images[i].file)
        } else {
          videoFiles.push(images[i].file)
        }
      } catch (error) {
        existingImageUrls.push({ media: images[i] })
      }
    }
    return { imageFiles, videoFiles }
  }

  useEffect(() => {
    //call api to update store
    dispatch(getMediaCoverageTypesList())
  }, [])

  const handleClickOpenDeleteDialog = () => {
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = () => setOpenDeleteDialog(false)

  useEffect(() => {
    setType(mediaCoverageTypesList && mediaCoverageTypesList[0]?.type)
  }, [mediaCoverageTypesList])

  const handleDelete = (index) => {
    hiddenFileInput.current.value = ''
    let elementToRemove = images[index]
    const tempImages = [...images]
    tempImages.splice(index, 1)
    setImages(tempImages)
    let uploadIndex = files.findIndex((ele) => ele === elementToRemove)
    const tempFiles = [...files]
    if (uploadIndex > -1) {
      tempFiles.splice(uploadIndex, 1)
    }
    setFiles(tempFiles)
    setCheckUpdateChanges(false)
  }

  useEffect(() => {
    const parameters = {
      useridtype: getIds(),
    }
    sendCreateMedaiCoverageLogs('pageload', parameters)
    sendGALog('pop_up')
  }, [])

  const sendGALog = (event) => {
    const page_title = onViewClickTitleValue === 5 ? 'create_miscellaneous_popup' : 'create_books_media_popup'
    const payload = {
      event,
      page_title,
    }
    pushTag(payload)
  }

  const sendCloseDialogLog = () => {
    const parameters = {
      useridtype: getIds(),
    }
    sendCreateMedaiCoverageLogs('cancel', parameters)
    sendGALog('back')
  }

  const sendCreateMedaiCoverageLogs = async (type, parameters) => {
    await makeLogRequest('create_books_and_media_coverage_popup', type, parameters)
  }

  const processFile = async (file) => {
    const reader = new FileReader()
    const readerPromise = new Promise((resolve, reject) => {
      reader.readAsDataURL(file)
      reader.onload = () => {
        resolve({
          type: file.type.startsWith('image') ? 'image' : 'video',
          url: reader.result,
          file: file,
        })
      }
      reader.onerror = (error) => {
        reject(error)
      }
    })

    try {
      const result = await readerPromise // Wait for the FileReader to complete
      return result
    } catch (error) {
      console.error('Error reading file:', error)
      throw error
    }
  }

  const handleImageChange = async (e) => {
    const parameters = {
      useridtype: getIds(),
    }
    sendCreateMedaiCoverageLogs('add_more_images', parameters)
    let uploadedFiles = Array.from(e.target.files)
    let processedImages = 0
    let imgFiles = uploadedFiles.filter((x) => x.type.includes('image'))
    if (uploadedFiles.some((x) => x.name.endsWith('.flv'))) {
      showNotification('Error', 'Please upload video in MP4 format only', 'error')
    } else if (uploadedFiles.some((x) => !x.type.includes('image') && !x.type.includes('video'))) {
      showNotification('Error', 'Please upload media in JPG, PNG or MP4 format only', 'error')
    }

    for (let i = 0; i < imgFiles.length; i++) {
      const isDuplicate = files.some((file) => typeof file != 'string' && file.file.name === imgFiles[i].name)
      if (isDuplicate) {
        showNotification('Error', 'This image is already uploaded.', 'error')
        imgFiles.splice(i, 1)
        i--
        continue
      }

      const isRightFormat = allowedImageFormat.includes(imgFiles[i].type)
      const fileSizeInBytes = imgFiles[i].size
      const maxSizeInBytes = 20 * 1024 * 1024 // 20MB
      if (!isRightFormat) {
        showNotification('Error', 'Please upload image in JPG or PNG format only', 'error')
        e.target.value = null
        return
      }
      if (fileSizeInBytes > maxSizeInBytes) {
        showNotification('Error', 'Please upload image with size less than 20MB', 'error')
        e.target.value = null
        return
      }
      setCheckUpdateChanges(false)
      processedImages++
    }
    const processingPromises = imgFiles.map((file) => processFile(file))
    await Promise.all(processingPromises)
      .then((newFiles) => {
        setFiles((prevFiles) => [...prevFiles, ...newFiles])
        if (processedImages === imgFiles.length) {
          setImages([...images, ...newFiles])
        }
      })
      .catch((error) => {
        console.error('Error processing files:', error)
      })
    handleVideoFilesUpload(uploadedFiles)
  }

  const uploadTrimmedVideo = (video) => {
    setImages((prevFiles) => [...prevFiles, video])
    setFiles([...files, video])
  }

  const handleVideoFilesUpload = (uploadedFiles) => {
    let videoFiles = uploadedFiles.filter((x) => x.type.includes('video'))
    if (!videoFiles || videoFiles?.length < 1) return
    let maxAllowedVideoSize = 100 * 1024 * 1024 // 100MB
    let maxAllowedVideoDuration = 10 * 60 // 10 mins
    let videoFilesAdded =
      images?.some((x) => typeof x === 'string' && x.endsWith('.mp4')) || files?.some((x) => x.type === 'video')
    if (videoFilesAdded || videoFiles?.length > 1) {
      showNotification('Error', 'Only one video file is allowed', 'error')
    } else if (videoFiles[0]?.type !== 'video/mp4') {
      showNotification('Error', 'Please upload video in MP4 format only', 'error')
    } else if (videoFiles[0]?.size > maxAllowedVideoSize) {
      showNotification('Error', 'Please upload video with size less than 100MB', 'error')
    } else if (!videoFilesAdded && videoFiles?.length > 0) {
      getVideoFileDuration(videoFiles[0], async (duration) => {
        if (duration > maxAllowedVideoDuration) {
          showNotification('Error', 'Please upload a video with duration less than 10 minutes', 'error')
        } else {
          setCheckUpdateChanges(false)
          console.log(duration, 'duration')
          await handleOpenTrimDialog(duration, videoFiles)
        }
      })
    }
  }

  const handleOpenTrimDialog = async (duration, videoFiles) => {
    try {
      setLoading(true)
      let videoFilesObject = {
        videoFiles: [...videoFiles],
      }
      console.log(duration, 'duration')
      let vidsURLObj = await uploadFile(videoFilesObject, 'media.mp4')
      let videoUrl = vidsURLObj?.videoUrls[0]
      let framesResponse = await getFramesFromVideo({
        videoUrl: videoUrl,
        thumbnailCount: 7,
      })
      setVideoData({
        videoUrl,
        duration,
        frames: framesResponse.data.slice(0, 7),
      })
      setOpenVideoTrimDialog(true)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const handlePreview = (file) => {
    // if (file.type === "image" || details) {
    //     return <img src={typeof file === 'string' ? file : file.url} alt="Preview" className="imageupload form-img__img-preview-ed1" id="imageupload" />;
    // }
    // if (file.type === "video" || details) {
    //     return (
    //         <video controls className="imageupload form-img__img-preview-ed1" id="imageupload">
    //             <source src={typeof file === 'string' ? file : file.url} />
    //             Your browser does not support the video tag.
    //         </video>
    //     );
    // }
    if (file.type === 'image') {
      return (
        <img
          src={typeof file === 'string' ? file : file.url}
          alt="Preview"
          className="imageupload form-img__img-preview-ed1"
          id="imageupload"
          onESrror={(e) => (e.target.src = NoImageFound)}
          sx={{
            width: '150px',
            height: '150px',
            borderRadius: '20px',
          }}
        />
      )
    }
    if (file.type === 'video') {
      return (
        <video
          controls
          disablePictureInPicture
          controlsList="nodownload noplaybackrate"
          className="imageupload form-img__img-preview-ed1"
          id="imageupload"
        >
          <source src={typeof file === 'string' ? file : file.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )
    }
    const images = ['jpg', 'gif', 'png', 'svg', 'jfif', 'jpeg']
    const videos = ['mp4', '3gp', 'ogg']
    const url = new URL(file)
    const extension = url.search.split('.')[1]
    const pathExtension = url?.pathname?.slice(url.pathname.lastIndexOf('.') + 1, url.pathname.length) || ''
    if (images.includes(extension?.toLowerCase()) || images.includes(pathExtension?.toLowerCase())) {
      return <img src={file} alt="Preview" className="imageupload form-img__img-preview-ed1" id="imageupload" />
    }
    if (videos.includes(extension?.toLowerCase()) || videos.includes(pathExtension?.toLowerCase())) {
      return (
        <Box>
          {/* <img src={playicon} onClick={handleHideImage} /> */}
          <video
            controls
            disablePictureInPicture
            controlsList="nodownload noplaybackrate"
            className="imageupload form-img__img-preview-ed1"
            id="imageupload"
          >
            <source src={typeof file === 'string' ? file : file.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>
      )
    }
  }

  const handleClick = (event) => {
    hiddenFileInput.current.click()
  }

  const handleCancelClick = () => {
    handleCloseMediaCoverage(reset, setImages, setFiles)
    sendGALog('back')
  }

  return (
    <>
      <Dialog
        open={openMediaCoverage}
        onClose={() => (
          handleCloseMediaCoverage(reset, setImages, setFiles), isMediaCoverageEdit && postAuditLogs('close')
        )}
        sx={{ height: '96vh', mt: 2.5, overflowX: 'hidden' }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#357092',
                fontFamily: 'HK Grotesk',
                fontSize: '26px',
                fontWeight: 'bold',
              }}
            >
              {onViewClickTitleValue === 5 ? 'Miscellaneous' : 'Media Coverage'}
            </Typography>
            <Avatar
              onClick={() => {
                sendCloseDialogLog()
                handleCloseMediaCoverage(reset, setImages, setFiles)
                isMediaCoverageEdit && postAuditLogs('close')
              }}
              src={CrossIcon}
              className="closeIcon"
              sx={{
                height: '30px',
                width: '30px',
                position: 'absolute',
              }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white" sx={{ overflowX: 'hidden' }}>
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 4 }}>
              <Box>
                <form>
                  <Grid container spacing={1} justifyContent="left" alignItems="center">
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12} sx={{ pr: 1 }}>
                        <FormControl
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderRadius: '14px',
                            },
                          }}
                        >
                          <Typography className="add-media-coverage-input-label">Title*</Typography>
                          <TextField
                            className="stepperFormInput"
                            // label="Title"
                            name="title"
                            fullWidth
                            placeholder="Enter title"
                            size="small"
                            required
                            inputProps={{ maxLength: 300, minLength: 10 }}
                            defaultValue={details && details?.title}
                            autoComplete="off"
                            {...register('projectTitle', {
                              required: 'Please enter title',
                              maxLength: {
                                value: 300,
                                message: 'Max length 300',
                              },
                              minLength: {
                                value: 10,
                                message: 'Minimum character length is 10',
                              },
                              validate: (value) => validateNotEmpty(value, 'title'),
                            })}
                            //   error={Boolean(errors?.employeeId?.message)}
                            //   helperText={errors?.employeeId?.message}
                            onChange={setMediaTitle}
                          />
                        </FormControl>
                        <FormHelperText sx={{ color: '#d32f2f' }}>
                          {errors && errors?.projectTitle?.message}
                        </FormHelperText>
                      </Grid>
                    </Grid>
                    {onViewClickTitleValue === 5 ? (
                      <Grid container sx={{ mb: 2 }}>
                        <Grid item xs={12}>
                          <Typography className="add-media-coverage-input-label">Type*</Typography>
                          <FormControl
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '14px',
                              },
                            }}
                          >
                            <InputLabel id="demo-simple-select-label" sx={{ marginTop: '-6px' }}></InputLabel>
                            <Select
                              className="stepperFormInput w-50"
                              name="type"
                              IconComponent={selectArrow ? iconComponent : iconComponentDown}
                              onOpen={() => setSelectArrow(false)}
                              onClose={() => setSelectArrow(true)}
                              defaultValue={details?.type}
                              required
                              size="small"
                              autoComplete="off"
                              {...register('type', {
                                required: 'Please select type',
                              })}
                              SelectDisplayProps={{
                                renderValue: (defaultValue) => defaultValue,
                              }}
                              onChange={handleTypeChange}
                            >
                              {mediaCoverageTypesList &&
                                mediaCoverageTypesList.map((s) => {
                                  return (
                                    <MenuItem native key={s.type} sx={{ width: '100%' }} value={s.type} size="small">
                                      {s.type}
                                    </MenuItem>
                                  )
                                })}
                            </Select>
                            <FormHelperText sx={{ color: '#d32f2f', ml: '10px', mr: 0 }}>
                              {errors && errors?.type?.message}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container sx={{ mb: 2 }}>
                        <Grid item xs={12}>
                          <Typography className="add-media-coverage-input-label">Type*</Typography>
                          <Box className="Media-coverage-button">
                            <Typography className="media-coverage-text">Media Coverage</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                    <Grid container>
                      <Typography className="add-media-coverage-input-label mb-0">Attach Media*</Typography>
                      <Box className="contpopup1 media-box">
                        {/* {images?.length > 0 ? ( */}
                        <>
                          <Box className="postionabs-2 itemfixed-update media-container">
                            {images?.length > 1 ? (
                              <Tabs
                                // value={value}
                                // onChange={handleChange}
                                variant="scrollable"
                                scrollButtons
                                aria-label="visible arrows tabs example"
                                sx={{
                                  [`& .${tabsClasses.scrollButtons}`]: {
                                    '&.Mui-disabled': { opacity: 0.3 },
                                  },
                                }}
                              >
                                {images?.map((file, index) => (
                                  <Card
                                    sx={{
                                      minWidth: 200,
                                      borderRadius: 0,
                                      boxShadow: 'none',
                                    }}
                                    className="form-img__img-preview-ed1 "
                                  >
                                    <CardContent className="position-relative">
                                      {/* <img width="38.49" src={first} className="position-absolute" alt="" /> */}
                                      <Box key={index}>{handlePreview(file)}</Box>
                                      {/* <img key={index} src={typeof image === 'string' ? image : image.url} alt="" className="form-img__img-preview" /> */}
                                      <Avatar
                                        src={closeIconp}
                                        onClick={() => handleDelete(index)}
                                        className="imageclose-2"
                                        sx={{
                                          width: '22px',
                                          height: '22px',
                                          padding: '5px',
                                          position: 'absolute',
                                        }}
                                      />
                                      {/* <Button onClick={() => handleDelete(index)}>delete</Button> */}
                                    </CardContent>
                                  </Card>
                                ))}
                              </Tabs>
                            ) : (
                              images?.map((file, index) => (
                                <Card
                                  sx={{
                                    minWidth: 200,
                                    borderRadius: 0,
                                    boxShadow: 'none',
                                  }}
                                  className="form-img__img-preview-ed1"
                                >
                                  <CardContent>
                                    {/* <img width="38.49" src={first} className="position-absolute" alt="" /> */}
                                    <Box key={index}>{handlePreview(file)}</Box>
                                    {/* <img key={index} src={typeof image === 'string' ? image : image.url} alt="" className="form-img__img-preview" /> */}
                                    {/* <Button onClick={() => handleDelete(index)}>delete</Button> */}
                                    <Avatar
                                      src={closeIconp}
                                      onClick={() => handleDelete(index)}
                                      className="imageclose-2"
                                      sx={{
                                        width: '22px',
                                        height: '22px',
                                        padding: '5px',
                                        position: 'absolute',
                                      }}
                                    />
                                  </CardContent>
                                </Card>
                              ))
                            )}
                          </Box>
                          <Grid item xs={6}>
                            <input
                              type="file"
                              ref={hiddenFileInput}
                              className="d-none"
                              multiple
                              onChange={handleImageChange}
                              accept={`${acceptedImageFormat}, video/mp4`}
                              onClick={(event) => {
                                event.target.value = null
                              }}
                            />
                            {/* <input type="file" ref={hiddenFileInput} style={{ display: 'none' }} multiple onChange={handleImageChange} /> */}
                            <Box
                              sx={{
                                // ml: "-95px",
                                display: 'flex',

                                // position: 'relative',
                                '& > :not(style)': {
                                  width: 150,
                                  height: 140,
                                  // position: "relative",
                                  //  left: "-31%",
                                  // top: "8%",
                                  // marginTop: "32px",
                                },
                              }}
                            >
                              <Paper
                                variant="outlined"
                                square
                                sx={{
                                  border: 'dotted 3px #1976d2',
                                  padding: '50px',
                                  width: '40%',
                                  borderRadius: '14px',
                                }}
                              >
                                <IconButton
                                  color="primary"
                                  aria-label="Upload"
                                  onClick={() => (
                                    handleClick(), isMediaCoverageEdit && postAuditLogs('add_more_images')
                                  )}
                                  sx={{
                                    display: 'flex',
                                    marginTop: '-10px',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <UploadIcon />
                                </IconButton>

                                <Typography
                                  className="d-flex justify-content-center position-relative text-nowrap"
                                  sx={{
                                    fontFamily: 'HK Grotesk',
                                    fontWeight: 700,
                                  }}
                                >
                                  {' '}
                                  {images?.length > 0 ? 'Add More Media' : 'Add Media'}
                                </Typography>
                                <FormHelperText
                                  sx={{
                                    color: '#d32f2f',
                                    width: 'max-content',
                                    marginTop: '38px',
                                    marginLeft: '-45px !important',
                                  }}
                                >
                                  {checkImages && images.length === 0 && 'Please upload media'}
                                </FormHelperText>
                              </Paper>
                            </Box>
                          </Grid>
                        </>
                        {/* ) : null} */}
                        {/*  */}
                      </Box>
                    </Grid>

                    <Grid container sx={{ mb: 2, mt: 1 }}>
                      <Grid item xs={12} sx={{ pr: 1 }}>
                        <FormControl
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderRadius: '14px',
                            },
                          }}
                        >
                          <Typography className="add-media-coverage-input-label desc-box">Description*</Typography>
                          <TextField
                            className="stepperFormInput"
                            // label="Description"
                            name="desc"
                            placeholder="Enter Description"
                            fullWidth
                            required
                            multiline
                            rows={4}
                            defaultValue={details && details.desc}
                            size="small"
                            inputProps={{ maxLength: 5000, minLength: 10, wrap: 'soft' }}
                            autoComplete="off"
                            {...register('desc', {
                              required: 'Please enter description',
                              maxLength: {
                                value: 5000,
                                message: 'Maximum 5000 characters allowed',
                              },
                              minLength: {
                                value: 10,
                                message: 'Minimum character length is 10',
                              },
                              validate: (value) => validateNotEmpty(value, 'description'),
                            })}
                            onChange={(e) => {
                              let inputValue = e.target.value?.trimStart()
                              inputValue = inputValue.replace(/\s{2,}/g, ' ')
                              checkTextField(inputValue, 5000, 10, 'desc', 'description')
                              setValue('desc', inputValue)
                              setCheckUpdateChanges(false)
                              if (e.target.value !== '') {
                                setCheckDescValue(true)
                              } else {
                                setCheckDescValue(false)
                              }
                              if (e.target.value.replaceAll('\n', '').length > 5000) {
                                setCheckDescValue(false)
                                setCheckDescError(true)
                                setCheckDescChanges(true)
                              } else {
                                setCheckDescError(false)
                                setCheckDescChanges(false)
                              }
                              setCheckUpdateChanges(false)
                            }}
                            onPaste={(e) => {
                              const pastedText = e.clipboardData.getData('text')
                              if (
                                pastedText.replace(/[\r\n]/gm, '').length +
                                  e.target.value.replace(/[\r\n]/gm, '').length >
                                5000
                              ) {
                                e.preventDefault()
                                const truncatedText = pastedText.substring(0, 5000 - e.target.value.length)
                                document.execCommand('insertText', false, truncatedText)
                                setCheckDescError(true)
                              }
                            }}
                          />
                        </FormControl>
                        <FormHelperText
                          sx={{
                            color: errors && errors?.desc?.message ? '#d32f2f !important' : 'blue !important',
                          }}
                        >
                          {errors && errors?.desc?.message
                            ? errors && errors?.desc?.message
                            : checkDescError || checkDescValue
                            ? 'Maximum 5000 characters allowed'
                            : errors?.desc?.message}
                        </FormHelperText>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} sx={{ pr: 1 }}>
                        <FormControl
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderRadius: '14px',
                            },
                          }}
                        >
                          <Typography className="add-media-coverage-input-label link-box">Link</Typography>

                          <TextField
                            className="stepperFormInput"
                            // label="Link"
                            name="url"
                            // placeholder="Link"
                            fullWidth
                            required
                            defaultValue={details && details.url}
                            size="small"
                            autoComplete="off"
                            inputProps={{ maxLength: 150, minLength: 10, onPaste: handlePaste }}
                            onKeyDown={(e) => {
                              if (e.key === ' ') {
                                e.preventDefault()
                              }
                            }}
                            onInput={handleInput}
                            {...register('url', {
                              //   required: "Please enter url",
                              minLength: {
                                value: 10,
                                message: 'Minimum character length is 10',
                              },
                              //   validate: (value) =>
                              //     validateNotEmpty(value, "url"),
                              validate: (value) => validateURL(value),
                              // , validate: {
                              //     pattern: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g,
                              //     // message: "Invalid "
                              // }
                            })}
                            onChange={() => {
                              setCheckUpdateChanges(false)
                            }}
                          />
                        </FormControl>
                        <FormHelperText sx={{ color: '#d32f2f' }}>{errors && errors?.url?.message}</FormHelperText>
                      </Grid>
                      <Grid item xs={12}>
                        {detailPdf?.name ? (
                          <>
                            <Typography
                              className="pdfUploadClass"
                              sx={{
                                fontWeight: 'bold',
                                marginTop: '20px',
                                fontFamily: 'HK Grotesk',
                              }}
                            >
                              {onViewClickTitleValue === 5 ? 'Miscellaneous PDF :' : 'Media Coverage PDF :'}
                            </Typography>
                            <PdfCard
                              url={detailPdf?.size ? detailPdf : details?.detailsPdf}
                              name={detailPdf.name}
                              detailPdf={setDetailPdf}
                              editable={true}
                              checkUpdate={setCheckUpdateChanges}
                            />
                          </>
                        ) : (
                          <>
                            <input
                              ref={PdfEventFileInput}
                              className="d-none"
                              type="file"
                              accept=".pdf"
                              onChange={(e) => {
                                handlePdfChange(e)
                              }}
                            />
                            <AddPdfComponent
                              onClick={(e) => handlePdfClick(e)}
                              left="274px"
                              text={
                                onViewClickTitleValue === 5
                                  ? 'Add a PDF as your Miscellaneous'
                                  : 'Add a PDF as your Media Coverage'
                              }
                            />
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <React.Fragment>
              <Box sx={{ display: 'flex', flexDirection: 'row', p: 2, pl: 30 }}>
                {isMediaCoverageEdit ? (
                  <Button
                    variant="contained"
                    sx={{ p: 1, mr: 1, backgroundColor: '#ef7335' }}
                    // className="button-tr-2"
                    className={`button-tr-2-13-disa ${checkDescError || checkDescChanges ? 'button-tr-2-1' : ''}`}
                    onClick={handleSubmit(onAddMediaCoverage)}
                    onMouseUp={() => (
                      setCheckImages(true), setCheckDescValue(false), isMediaCoverageEdit && postAuditLogs('update')
                    )}
                    disabled={checkUpdateChanges}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    sx={{ p: 1, mr: 1, backgroundColor: '#ef7335' }}
                    // className="button-tr-2"
                    className={`button-tr-2-13-disa ${checkDescError || checkDescChanges ? 'button-tr-2-1' : ''}`}
                    onClick={handleSubmit(onAddMediaCoverage)}
                    onMouseUp={() => (
                      setCheckImages(true), setCheckDescValue(false), isMediaCoverageEdit && postAuditLogs('update')
                    )}
                    disabled={checkDescChanges && true}
                  >
                    Submit
                  </Button>
                )}

                {isMediaCoverageEdit && (
                  <Button
                    variant="outlined"
                    onClick={() => (handleClickOpenDeleteDialog(), postAuditLogs('delete'))}
                    sx={{ p: 1, mr: 1 }}
                    className="button-tr-2-1 "
                  >
                    Delete
                  </Button>
                )}
                {!isMediaCoverageEdit && (
                  <Button
                    variant="outlined"
                    onClick={handleCancelClick}
                    sx={{ p: 1, mr: 1 }}
                    className="button-tr-2-1 "
                  >
                    Cancel
                  </Button>
                )}
                {/* <div style={{ marginTop: "12px" }}>
                                    {isMediaCoverageEdit && (
                                        <img
                                            src={imagedelete}
                                            onClick={handleClickOpenDeleteDialog}
                                            className="deleteimgcss1 cursorshow"
                                            style={{ marginTop: "0px", marginLeft: "15px" }}
                                            alt="delete"
                                        />
                                    )}
                                </div> */}
                <Box sx={{ flex: '1 1 auto' }} />
              </Box>
            </React.Fragment>
            {openDeleteDialog && (
              <DeleteMediaCoverageDialog
                openDeleteDialog={openDeleteDialog}
                handleCloseDeleteDialog={handleCloseDeleteDialog}
                opedId={details?.id}
                mpId={mpProfileData?.id || mpId}
                handleCloseMediaCoverage={handleCloseMediaCoverage}
                opedsByMpId={opedsByMpId}
                handleCloseInitiativeDetails={handleCloseInitiativeDetails}
                details={details}
                setDeleteClick={setDeleteClick}
                isMediaCoverageEdit={isMediaCoverageEdit}
                isMiscellaneous={onViewClickTitleValue === 5}
                limit={limit}
                tenure={tenure}
              />
            )}
            {openVideoTrimDialog && (
              <VideoTrimDialog
                openVideoTrimDialog={openVideoTrimDialog}
                onUpload={uploadTrimmedVideo}
                onCancel={setOpenVideoTrimDialog}
                videoData={videoData}
                setVideoData={setVideoData}
              />
            )}
          </Grid>
        </Grid>
      </Dialog>
    </>
  )
}

export default AddMediaCoverage
